import { getProcessEnvs } from './getProcessEnvs';

enum Environment {
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
}

export const getEnv: () => Environment = () => {
  const publicRuntimeConfig = getProcessEnvs();
  const env = publicRuntimeConfig.ENVIRONMENT || 'development';
  switch (env) {
    case Environment.Development:
    case Environment.Staging:
    case Environment.Production:
      return env;
    default:
      throw new Error(`Invalid environment ${env}`);
  }
};
